type PosterFields = {
    poster?: { big: string; small?: string }
    poster_mobile?: { big: string; small?: string }
}

type ResponsiveFilmPosterProps = {
    film: PosterFields
    alt: string
    className?: string
}

/** poster — десктоп (вертикальный), poster_mobile — мобильный (широкий баннер) */
export default function ResponsiveFilmPoster({ film, alt, className = "size-full object-cover" }: ResponsiveFilmPosterProps) {
    const desktop = film.poster?.big ?? film.poster_mobile?.big
    const mobile = film.poster_mobile?.big ?? film.poster?.big

    if (!desktop && !mobile) return null

    return (
        <>
            {mobile && <img src={mobile} alt={alt} className={`${className} md:hidden`} />}
            {desktop && <img src={desktop} alt={alt} className={`${className} hidden md:block`} />}
        </>
    )
}

export function filmPosterData(film: PosterFields) {
    return {
        poster: film.poster?.big ?? "",
        poster_mobile: film.poster_mobile?.big ?? "",
    }
}
